import { TTableColumn } from '@treezor/design-system';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { isWalletsSortKeyAvailable } from '@/features/wallets/store/models/wallet.model';
import { TAllWalletsRowType } from '@/features/wallets/store/models/allWallets.model';

export function AllWalletsHeaders({ headersList }: { headersList: (keyof TAllWalletsRowType)[] }) {
  const { t } = useTranslation();

  const getHeaderLabel = useCallback(
    (label: keyof TAllWalletsRowType): string => {
      switch (label) {
        case 'iban':
          return `${t('pages.currentProfiles.wallets.wallet.iban')} & ID`;
        case 'actions':
          return '';
        default:
          return t(`pages.currentProfiles.wallets.wallet.${label.toString()}`);
      }
    },
    [t],
  );

  return headersList.map(
    (field: keyof TAllWalletsRowType): TTableColumn<TAllWalletsRowType> => ({
      name: field,
      isSortable: isWalletsSortKeyAvailable(field) || undefined,
      field,
      label: (
        <div className={`w-full ${['statusCode'].includes(field.toString()) ? 'text-center' : ''}`}>
          {getHeaderLabel(field)}
        </div>
      ),
    }),
  );
}
